module.exports = __webpack_public_path__ + "img/tenders-veganos.694e28cd.jpg";